<object
  class="logo"
  type="image/svg+xml"
  data="/img/logo-text.svg"
></object>


<div class="content">

  <img src="/img/warning.gif" alt="warning" class="warning">

  <span>
    <span [innerHTML]="'JointInfo.Title' | translate"></span>
    <br>
    <span [innerHTML]="'JointInfo.SubTitle' | translate"></span>
  </span>

  <button (click)="workspaceService.next()">
    {{ 'JointInfo.Continue' | translate }}
    <span class="symbol"> &larr; </span>
  </button>

</div>

